import { render } from "./FaqRow.vue?vue&type=template&id=5776141e"
import script from "./FaqRow.vue?vue&type=script&lang=js"
export * from "./FaqRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__